import { legacyPlugins } from "/opt/build/repo/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.154.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_b569a795b0dc32667c94c47346efa972/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}